import Colors from './color'
import FontSize from './fontSize'

export { Colors, FontSize }
